import React from 'react';

function Column(props) {
    const {links, simplified} = props
    const {section: section_name, links: link_list} = links || ''
    
    let names = [];
    link_list.map((item, index) => {
        names.push(<li key={index}><a href={item.href}>{item.text}</a></li>)
        return names;
    })

    return(
        <div className="col-sm-3">
            {!simplified ? 
            <>
                <h2>{section_name}</h2>
                <ul className="list-unstyled">
                    {names}
                </ul>
            </> : null
            }
            
        </div>
    )
}

export default Column;